import io from "socket.io-client";

// export const socketServer = "https://sv2.barnet.app/";
export const socketServer = "https://barnet.app/";
// http://193.176.240.240:88/
// http://217.11.29.130:88/
// 80
// https://sv2.barnet.app/
// eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtb2JpbGUiOiIwOTEwMjExOTExOCIsImVtYWlsIjpudWxsLCJfaWQiOiI1ZWU3OWUxYzk0ZWQ3YTExNTA3OWM4YjMiLCJJc01lbWJlciI6dHJ1ZSwiaWF0IjoxNjQwMjQ1ODIzLCJleHAiOjE2NDI4Mzc4MjN9.zpH4j93jZMzhHLKhta0ST86DJ0ZNRn1dy1iYtPsFmI0

const socket = io.connect(socketServer, {
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: Infinity,
});

console.log("socket instance", socket);
window.socket = socket;
// window.io = io;

// https://barnet.app/uploaded_profile_images/b6a9b8e6-8707-3f7c-61dc-0244cbd313fd.jpg

export default socket;

// ارزش بار  3179774000 ی
